// Lógica pura de "Subir a Mercado Libre": tipos de lo que devuelve el backend y cómo
// contarle a la persona qué pasó con la foto. Sin red ni DOM (se prueba con vitest).
// Ver ADR-2026-09-28-mercadolibre-subir-fotos-sin-borrar-nada (atlas-backend).

export interface ColorDePublicacion {
  variation_id: string;
  etiqueta: string;
  fotos: number;
  miniatura: string | null;
}

export interface PublicacionParaSubir {
  item_id: string;
  titulo: string;
  estado: string | null;
  es_catalogo: boolean;
  fotos: number;
  max_fotos: number;
  permalink: string | null;
  miniatura: string | null;
  bloqueo: string | null;
  colores: ColorDePublicacion[];
}

export interface DiagnosticoDeFoto {
  apta: boolean;
  motivos: string[];
  sin_diagnostico: boolean;
}

/** Lo que devuelve el job `ml_export_fotos` en su `output`. */
export interface ResultadoDeSubida {
  subidas?: number;
  como_secundaria?: Array<{ exportacion_id: string; motivos: string[] }>;
  errores?: Array<{ exportacion_id: string; motivo: string }>;
}

/** Qué decirle a la persona cuando termina la subida. */
export function resumenDeSubida(r: ResultadoDeSubida | null | undefined): { texto: string; ok: boolean } {
  if (!r) return { texto: "La foto se está subiendo. En unos minutos la vas a ver en tu publicación.", ok: true };
  const error = r.errores?.[0]?.motivo;
  if ((r.subidas ?? 0) === 0 && error) return { texto: error, ok: false };
  const secundaria = r.como_secundaria?.[0];
  if (secundaria) {
    return {
      texto: `Listo. La subimos como foto secundaria: ${secundaria.motivos.join(" ")} En Mercado Libre puede aparecer "procesando" unos minutos.`,
      ok: true,
    };
  }
  return { texto: 'Listo. En Mercado Libre puede aparecer "procesando" unos minutos.', ok: true };
}

/** ¿Hay lugar para una foto más? */
export function hayLugar(p: Pick<PublicacionParaSubir, "fotos" | "max_fotos">): boolean {
  return p.fotos < p.max_fotos;
}
